export enum TAccountSpotStatus {
  ACCOUNT_STATUS_ACTIVE = 1,
  ACCOUNT_STATUS_CONNECTING = 2, // акаунт в процесі підключення, не готовий до роботи
  ACCOUNT_STATUS_DISCONNECTED = 3, // клієнт відключив інтеграцію
  ACCOUNT_STATUS_ARCHIVED = 4, // акаунт в постері заархівований
}
